import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IRosterSummaryLine } from "../shared/models/roster/roster-summary-line";
import { ApiUrlProvider } from "./api-url.provider";
import { IEmployer } from "../shared/models/employer";

@Injectable({
  providedIn: "root"
})
export class RosterSummaryLineService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterSummaryLine[]>>{
    return this.http.get<IApiResult<IRosterSummaryLine[]>>(`${this.apiUrlProvider.url}/RosterSummaryLine`);
  }

  add(entity: IRosterSummaryLine): Observable<IApiResult<IRosterSummaryLine>>{
    return this.http.post<IApiResult<IRosterSummaryLine>>(`${this.apiUrlProvider.url}/RosterSummaryLine`, entity);
  }

  update(entity: IRosterSummaryLine): Observable<IApiResult<IRosterSummaryLine>>{
    return this.http.post<IApiResult<IRosterSummaryLine>>(`${this.apiUrlProvider.url}/RosterSummaryLine/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/RosterSummaryLine/${entityId}/delete`, null);
  }

  deleteGroup(entity: IRosterSummaryLine): Observable<IApiResult<IRosterSummaryLine>>{
    return this.http.post<IApiResult<IRosterSummaryLine>>(`${this.apiUrlProvider.url}/RosterSummaryLine/${entity.id}/DeleteGroup`, entity);
  }

  getEmployersByCommaSeperatedIds(employerIds: string, employers: IEmployer[]): IEmployer[]{
    let result: IEmployer[] = [];

    if (!employerIds){
      return result;
    }

    result = employerIds.split(",").map(eid => employers.find(er => er.id === parseInt(eid)));
    return result;
  }

}
